<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <ChemicalTargets />
    </div>
</template>

<script>
import currentUserQuery from '@views/ChemicalTargets/Browse/queryCurrentUser.graphql';

import ChemicalTargets from '../ChemicalTargets/Browse.vue';

export default {
  name: 'ChemicalTargetsContainer',
  components: {
    ChemicalTargets,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['association', 'developer', 'admin'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
